<template>
  <main class="ce-loginPage flex-auto">
    <div
      class="ce-loginPage-contentWrapper"
      v-cloak>
      <div class="ce-loginPage-header">
        <div class="ce-loginPage-logoWrapper">
          <img
            src="https://assets-static.colormaterials.sunchemical.com/logo/sun-chemical-logo.png"
            width="300"
            alt="Sun Chemical">
        </div>

        <div class="ce-loginPage-headerContent">
          <h1>
            <fa-icon icon="user" />
            {{ $t('login.modal.headline') }}
          </h1>

          <p>
            {{ $t('login.modal.description') }}
          </p>
        </div>
      </div>

      <UserLogin
        :show-register-cta="false"
        :show-forgot-password-cta="false" />
    </div>
  </main>
</template>

<script>
import { mapState } from 'vuex';
import UserLogin from 'components/UserLogin.vue';

export default {
  name: 'LoginPage',
  components: { UserLogin },
  computed: {
    ...mapState('user', ['registrationVisible', 'forgotPasswordVisible'])
  }
};
</script>

<style lang="less">
@import (reference) '~styles/includes/base';

.ce-loginPage {
  display: flex;
  justify-content: center;
  align-items: center;

  .ce-loginPage-contentWrapper {
    background: @color-mono-95;
    max-width: 600px;
    width: 90%;
    border-bottom: 2px solid @color-mono-90;
    box-shadow: 1px 1px 5px @color-mono-90;
  }

  .ce-loginPage-header {
    padding: 0 @space-3 @space-4 0;
    border-bottom: 1px solid @color-mono-90;

    @media screen and (min-width: @breakpoint-xxs) {
      display: flex;
    }

    .ce-loginPage-logoWrapper {
      max-width: 300px;
      width: 100%;
      .flex-none;
      padding: @space-4;

      @media screen and (min-width: @breakpoint-xxs) {
        width: 50%;
      }
    }

    img {
      margin-right: @space-3;
      max-width: 100%;
    }

    .ce-loginPage-headerContent {
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 100%;
      padding: 0 @space-4;

      @media screen and (min-width: @breakpoint-xxs) {
        padding: @space-4;
      }

      h1 {
        .h2;
        font-weight: 500;
        color: @color-light;
        margin: 0;
      }

      p:last-child {
        margin-bottom: 0;
      }
    }
  }

  .ce-userLogin-content {
    padding: @space-4 @space-3;

    @media screen and (min-width: @breakpoint-xxs) {
      padding: @space-5;
    }

  }
}
</style>
